<template>
	<div class="background" :class="{['background-'+color]: true, rotating: rotating}"></div>
</template>

<script>
export default {
	props: ['color','rotating'],
}
</script>
<style scoped lang="scss">

	.background {
		transition: all 0.3s;
		z-index: 0;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-image: url('../assets/pattern.svg');
		background-repeat: repeat;
		background-position: 0 0;
		background-attachment: scroll;
		animation: animatedBackground 500s linear infinite; 
		background-size: max(15vw,200px);
		transform-origin: center;

		&.rotating {
			pointer-events: auto;
			width: 100%;
			height: 100%;
			transform-origin: center center;
			background-size: cover;
			background-image: url("data:image/svg+xml,%3Csvg style='filter: invert(1)' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' id='Layer_1' data-name='Layer 1' viewBox='0 0 1003.97 1009.5'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill-rule:evenodd;fill:url(%23radial-gradient);%7D%3C/style%3E%3CradialGradient id='radial-gradient' cx='615.23' cy='557.75' r='503.37' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-opacity='0.3'/%3E%3Cstop offset='1' stop-color='transparent' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3Ctitle%3Eradial-stripes%3C/title%3E%3Cpath class='cls-1' d='M615.23,53V557.75L510.29,64ZM318.54,149.4,615.23,557.75,409.93,96.64Zm-140.44,156L615.23,557.75,240.13,220ZM113.24,505l502,52.76-480-156Zm21.94,208.74,480.05-156-502,52.76Zm105,181.76,375.1-337.74L178.1,810.13Zm169.8,123.37,205.3-461.11L318.54,966.1Zm205.3,43.64V557.75L510.29,1051.47Zm205.3-43.64L615.23,557.75l104.94,493.72Zm169.8-123.37L615.23,557.75,911.91,966.1Zm104.94-181.76-480-156,437.13,252.38ZM1117.21,505l-502,52.76,502,52.76Zm-64.85-199.62L615.23,557.75l480-156Zm-140.45-156L615.23,557.75,990.33,220ZM720.17,64,615.23,557.75,820.53,96.64Z' transform='translate(-113.24 -53)'/%3E%3C/svg%3E");
			background-position: center center;
			animation: rotate 30s infinite linear;
			@keyframes rotate {
				from {
					transform:rotate(0deg)  scale(3);
					transform-origin: center center;
				}
				to {
					transform:rotate(360deg)  scale(3);
					transform-origin: center center;
				}
			}
			
		}

		&.background-blue {
			background-color: $mondadori-blue;
		}
		&.background-light-blue {
			background-color: $mondadori-light-blue;
		}
		&.background-green {
			background-color: $mondadori-green;
		}
		&.background-cyan {
			background-color: $mondadori-cyan;
		}
		&.background-yellow {
			background-color: $mondadori-yellow;
		}
		&.background-orange {
			background-color: $mondadori-orange;
		}
		&.background-pink {
			background-color: $mondadori-pink;
		}

		
	}
	@keyframes rotatingBackground {
		from {
			transform: rotate(0);
		}
		to {
			transform: rotate(360deg) ;
		}
	}
	@keyframes animatedBackground {
		from {
			background-position: 0 0;
		}
		to {
			background-position: px(-10000) px(-10000);
		}
	}
</style>